module.exports = __webpack_public_path__ + "img/signed.936ae22f.svg";